export default {
  GENERIC: {
    TITLE: 'Moank | Flexibla lån utan säkerhet',
    DESCRIPTION: 'Moank erbjuder smarta finansiella produkter. Alltid enkelt, personligt och anpassat efter dina behov. Välkommen in för mer information.',
  },
};
